import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ReactEcharts from "echarts-for-react";
import ModuleHeader from "../components/ModuleHeader";
import { REM_CONFIG } from "@/utils/fontSize";
const ProjectInvestment = ({ className = "", data: customData, }) => {
    // 默认模拟数据（可被外部 props 覆盖）
    const defaultData = [
        {
            name: "神木化工",
            annualIncome: 1626,
            annualCost: 1477.77,
            operatingProfit: 148.23,
        },
        {
            name: "新疆化工",
            annualIncome: 3180,
            annualCost: 2790.36,
            operatingProfit: 389.64,
        },
        {
            name: "包头化工",
            annualIncome: 2400,
            annualCost: 2162.02,
            operatingProfit: 237.98,
        },
        {
            name: "榆林化工",
            annualIncome: 2560,
            annualCost: 292.84,
            operatingProfit: 267.16,
        },
    ];
    // 最终使用的数据（优先外部传入，否则用默认）
    const chartData = customData || defaultData;
    // 生成 ECharts 配置项
    const getEchartsOption = (data) => {
        const enterpriseNames = data.map((item) => item.name); // 提取企业名称作为 X 轴分类
        return {
            tooltip: {
                trigger: "axis", // 鼠标悬浮时触发“轴”级提示
                axisPointer: { type: "cross" }, // 十字准星指示器
                backgroundColor: "rgba(7, 31, 75, 0.8)",
                borderColor: "#446b9f",
                textStyle: {
                    color: "#fff",
                },
            },
            legend: {
                data: ["本年累计收入", "本年销售成本", "营业利润"],
                top: "4%",
                right: "center",
                orient: "horizontal", // 显式设置水平排列
                itemGap: 10, // 调整项目间距，避免过挤
                width: "100%", // 限制图例宽度，避免超出容器
                textStyle: { color: "#fff", fontSize: REM_CONFIG.fontSize.small }, // 图例文字颜色（适配深色背景）
            },
            grid: {
                left: "4%",
                right: "4%",
                bottom: "4%",
                containLabel: true, // 自动包含坐标轴标签
            },
            xAxis: {
                type: "category",
                data: enterpriseNames,
                axisLabel: { color: "#fff", fontSize: REM_CONFIG.fontSize.small }, // X 轴标签颜色
                axisLine: {
                    lineStyle: { color: "rgba(255,255,255,0.2)" }, // X 轴线样式
                },
            },
            yAxis: {
                type: "value",
                min: 0,
                minInterval: 1000,
                name: "金额（万元）",
                nameTextStyle: {
                    color: "#fff",
                    fontSize: REM_CONFIG.fontSize.small,
                    padding: [20, 0, 0, 10],
                }, // 坐标轴名称颜色
                axisLabel: {
                    color: "#fff",
                    fontSize: REM_CONFIG.fontSize.small,
                    formatter: "{value}",
                }, // Y 轴标签及格式化
                axisLine: {
                    lineStyle: { color: "rgba(255,255,255,0.2)" },
                },
                splitLine: {
                    lineStyle: { color: "rgba(255,255,255,0.1)", type: "dashed" }, // 分割线样式
                },
            },
            series: [
                // 系列1：本年累计收入（黄色渐变面积）
                {
                    name: "本年累计收入",
                    type: "line",
                    data: data.map((item) => item.annualIncome),
                    symbol: "circle", // 标记点样式（圆形）
                    symbolSize: 8,
                    lineStyle: { color: "#FFE190" }, // 折线颜色
                    itemStyle: { color: "#FFE190" }, // 标记点颜色
                    areaStyle: {
                        // 区域渐变填充（从顶部到底部透明度递减）
                        color: {
                            type: "linear",
                            x: 0,
                            y: 0,
                            x2: 0,
                            y2: 1,
                            colorStops: [
                                { offset: 0, color: "RGBA(91, 91, 72, 0.6)" }, // 上半部分透明度 0.5
                                { offset: 1, color: "RGBA(91, 91, 72, 0.1)" }, // 下半部分透明度 0.1
                            ],
                            global: false,
                        },
                    },
                },
                // 系列2：本年销售成本（青色渐变面积）
                {
                    name: "本年销售成本",
                    type: "line",
                    data: data.map((item) => item.annualCost),
                    symbol: "circle",
                    symbolSize: 8,
                    lineStyle: { color: "#60FFFF" },
                    itemStyle: { color: "#60FFFF" },
                    areaStyle: {
                        color: {
                            type: "linear",
                            x: 0,
                            y: 0,
                            x2: 0,
                            y2: 1,
                            colorStops: [
                                { offset: 0, color: "RGBA(22, 164, 164, 0.5)" },
                                { offset: 1, color: "RGBA(22, 164, 164, 0.1)" },
                            ],
                            global: false,
                        },
                    },
                },
                // 系列3：营业利润（蓝色渐变面积）
                {
                    name: "营业利润",
                    type: "line",
                    data: data.map((item) => item.operatingProfit),
                    symbol: "circle",
                    symbolSize: 8,
                    lineStyle: { color: "#287CE7" },
                    itemStyle: { color: "#287CE7" },
                    areaStyle: {
                        color: {
                            type: "linear",
                            x: 0,
                            y: 0,
                            x2: 0,
                            y2: 1,
                            colorStops: [
                                { offset: 0, color: "RGBA(32, 103, 223, 0.5)" },
                                { offset: 1, color: "RGBA(32, 103, 223, 0.1)" },
                            ],
                            global: false,
                        },
                    },
                },
            ],
        };
    };
    const echartsOption = getEchartsOption(chartData);
    return (_jsxs("div", { className: `
        relative 
        bg-gradient-to-t 
        from-[rgba(7,31,75,0.5)] 
        to-[rgba(6,32,66,0.2)] 
        flex flex-col 
       min-h-0
        ${className}
      `, children: [_jsx(ModuleHeader, { title: "\u9879\u76EE\u7ECF\u8425\u5206\u6790" }), _jsx("div", { className: "flex-1 w-full min-h-0", children: _jsx(ReactEcharts, { option: echartsOption, style: { width: "100%", height: "100%" } }) })] }));
};
export default ProjectInvestment;
